import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { CustoService } from 'src/app/admihair/service/custo.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-item-servico-detalhe-janela',
  templateUrl: './item-servico-detalhe-janela.component.html',
  styleUrls: ['./item-servico-detalhe-janela.component.scss']
})
export class ItemServicoDetalheJanelaComponent implements OnInit {

  empresaId?: number;
  loading: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  id?: number;
  itemServico?: ItemServico;

  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };

  custoTotal: number = 0;

  valorVenda: number = 0;
  valorLucroDesejado: number = 0;
  valorLucroObtido: number = 0;
  valorSugerido: number = 0;
  novoValorServico: number = 0;
  valorLucroObtidoAtual: number = 0;

  constructor(private itemServicoService: ItemServicoService,
    private custoService: CustoService,
    private utilStorage: UtilStorageService,
    private activatedRouter: ActivatedRoute,
    private erroService: ErroService) { }

  ngOnInit(): void {
    this.loading = true;
    this.empresaId = this.utilStorage.getEmpresa().id;
    this.carregarId();
    this.carregar();
  }

  carregarId() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  carregar() {
    this.itemServicoService.buscarItemServicoPorId(this.id).subscribe({
      next: (data: ItemServico) => {
        this.itemServico = data;
        this.obterCustos();
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    });
  }


  obterCustos() {
    this.custoService.obterDadosParaPrecificacao(this.empresaId).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.calcularLucroObtidoAtual();
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  calcularLucroObtidoAtual() {
    if (this.itemServico
      && this.itemServico.valorVenda
      && this.itemServico.valorVenda > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const valorCustosTotais = (somaPercentuais / 100) * this.itemServico.valorVenda;
      this.valorLucroObtidoAtual = Number((this.itemServico.valorVenda - valorCustosTotais).toFixed(2));
      this.custoTotal = (this.custoMedio.custoFixo + this.custoMedio.imposto + (this.itemServico.custoMaterial ?? 0)) / 100;
    } else {
      this.valorLucroObtidoAtual = 0;
    }
  }

  calcularLucroDesejado(event: any) {
    this.valorLucroDesejado = event.value ?? 0;
    if (this.valorLucroDesejado > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const sugestao = ((this.valorLucroDesejado * somaPercentuais) / ((somaPercentuais - 100) * -1)) + this.valorLucroDesejado;
      this.valorSugerido = sugestao;
    } else {
      this.valorSugerido = 0;
    }
  }

  calcularLucroObtido(valor?: number) {
    this.novoValorServico = valor ?? 0;
    if (this.novoValorServico > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const valorCustosTotais = (somaPercentuais / 100) * this.novoValorServico;
      if (this.novoValorServico) {
        this.valorLucroObtido = Number((this.novoValorServico - valorCustosTotais).toFixed(2));
      }
    } else {
      this.valorLucroObtido = 0;
    }
  }


  exibirMensagemSucesso() {
    this.messages = this.erroService.handleSuccess();
    this.messagemVisivel = true;
    this.rolarTela();
  }

  exibirMensagemErro(err: any) {
    this.messages = this.erroService.handleErro(err);
    this.messagemVisivel = true;
    this.rolarTela();
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
